var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddClassroom = function SvgAddClassroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add-classroom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.2,
    d: "M15.394 20.444a8.49 8.49 0 0 1-8.37 0C3.747 21.443 1.74 24.756 1 27.675h20.415c-.738-2.919-2.746-6.232-6.021-7.231ZM11.209 4.884a7.35 7.35 0 0 0-6.794 4.541 7.36 7.36 0 0 0 5.359 10.03 7.35 7.35 0 0 0 7.548-3.128A7.358 7.358 0 0 0 11.21 4.884Zm0 12.96a5.68 5.68 0 0 1-5.14-3.511h10.28a5.69 5.69 0 0 1-5.14 3.51ZM21.066 23.228H32a9.1 9.1 0 0 0-6.023-6.676 8.5 8.5 0 0 1-7.115.582 9.8 9.8 0 0 1-1.943 2.425 9.43 9.43 0 0 1 4.147 3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.2,
    d: "M19.951 10.445h6.981a5.67 5.67 0 0 1-5.14 3.499 5.3 5.3 0 0 1-1.762-.313 9 9 0 0 1-.453 1.745 7.354 7.354 0 0 0 9.421-5.496 7.363 7.363 0 0 0-6.397-8.836 7.35 7.35 0 0 0-7.008 3.364 9.1 9.1 0 0 1 4.358 6.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06D1BD",
    d: "M23.827 27.22c4.874 0 8.826-3.87 8.826-8.646 0-4.775-3.952-8.647-8.826-8.647S15 13.8 15 18.574s3.952 8.646 8.827 8.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.123 23.184V17.15h1.526v6.034zM21.87 20.93v-1.526h6.034v1.526z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add-classroom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v28H0z"
  })))));
};
export default SvgAddClassroom;